import { render, staticRenderFns } from "./NavigationDrawerHeader.vue?vue&type=template&id=fedb4eb8&scoped=true"
import script from "./NavigationDrawerHeader.vue?vue&type=script&lang=js"
export * from "./NavigationDrawerHeader.vue?vue&type=script&lang=js"
import style0 from "./NavigationDrawerHeader.vue?vue&type=style&index=0&id=fedb4eb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fedb4eb8",
  null
  
)

export default component.exports